var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"content"},[_c('div',{staticClass:"content__scrollable"},[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content__header"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("../assets/logo-home.svg"),"alt":"MyTutor Logo"}})])])
}]

export { render, staticRenderFns }